import React from 'react';
import styled from 'styled-components';

import {
  withRouter
  // ,
  // Link
} from 'react-router-dom';
import searchIcon from '../../../assets/images/search.png';
import { Image } from '../StyledComponents';
import axios from 'axios';
import { apiEndpoints } from '../../../config/config';

const SearchDiv = styled.div.attrs({
  className: 'Search'
})`
  padding: 8px;
  display: flex;
  align-items: center;

  font-family: 'Montserrat';
  font-size: 1.1875rem;
  font-weight: bold;
  font-style: italic;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

class SearchBar extends React.Component {
  state = {
    searchResults: null
  };

  goToSearchComponent = event => {
    console.log('Go to Search');
    if (event && event.defaultPrevented) {
      console.log('Default prevented');
      return; // Should do nothing if the default action has been cancelled
    }

    // console.log('event: ', event);

    let searchList = document.getElementById('SearchList');
    // var handled = false;
    if (event && event.key !== undefined && event.key === 'Enter') {
      // Handle the event with KeyboardEvent.key and set handled true.
      if (searchList) {
        searchList.style.display = 'none';
      }
      this.props.history.push({ pathname: '/search', state: 'change' });
    } else if (event && event.keyIdentifier !== undefined) {
      // Handle the event with KeyboardEvent.keyIdentifier and set handled true.
    } else if (event && event.keyCode !== undefined && event.keyCode === 13) {
      // Handle the event with KeyboardEvent.keyCode and set handled true.
      if (searchList) {
        searchList.style.display = 'none';
      }
      this.props.history.push({ pathname: '/search', state: 'change' });
    }

    // if (handled) {
    //   // Suppress "double action" if event handled
    //   event.preventDefault();
    // }
  };

  componentDidMount = () => {
    // window.addEventListener('keydown', this.goToSearchComponent());
  };

  componentWillUnmount = () => {
    // window.removeEventListener('keydown', this.goToSearchComponent());
  };

  goToSlug = slug => {
    // console.log('Came here!');
    this.props.history.push({ pathname: `${slug}`, state: 'change' });
  };

  render() {
    const searchActive = () => {
      let nav = document.getElementById('Nav');
      let search = document.getElementById('Search');
      // console.log('nav: ', nav);
      nav.style.display = 'none';

      search.style.width = '80%';
      search.style.border = '1px solid #4db2ec';
      search.style.borderRadius = '8px';
    };
    // let searchResults;
    const handleOnBlur = e => {
      // console.log('e: ', e.target);
      e.target.value = '';
      let nav = document.getElementById('Nav');
      let search = document.getElementById('Search');
      let searchList = document.getElementById('SearchList');

      if (nav) {
        nav.style.display = 'flex';
      }

      if (search) {
        search.style.width = 'unset';
        search.style.border = 'none';
        search.style.borderRadius = 'none';
      }

      if (searchList) {
        searchList.style.display = 'none';
      }
    };

    const handleInputChange = event => {
      // console.log('e.target.value: ', e.target.value);
      let enteredText = event.target.value;
      if (enteredText) {
        let url = `${apiEndpoints.searchInput}/${enteredText}`;
        let searchList = document.getElementById('SearchList');

        if (searchList) searchList.style.display = 'block';
        // console.log('url: ', url);
        axios.get(url).then(response => {
          // console.log('response: ', response);
          this.setState({ searchResults: response.data.searchResults });
        });
        // console.log('event: ', event);
        // console.log('event.key: ', event.key);
        // console.log('event.keyIdentifier: ', event.keyIdentifier);
        // console.log('event.keyCode: ', event.keyCode);
        if (event && event.key !== undefined && event.key === 'Enter') {
          // Handle the event with KeyboardEvent.key and set handled true.
          if (searchList) {
            searchList.style.display = 'none';
          }
          this.props.history.push({
            pathname: `/search/results/${enteredText}`,
            state: 'change',
            params: enteredText
          });
        } else if (event && event.keyIdentifier !== undefined) {
          // Handle the event with KeyboardEvent.keyIdentifier and set handled true.
        } else if (
          event &&
          event.keyCode !== undefined &&
          event.keyCode === 13
        ) {
          // Handle the event with KeyboardEvent.keyCode and set handled true.
          if (searchList) {
            searchList.style.display = 'none';
          }
          this.props.history.push({
            pathname: `/search/results/${enteredText}`,
            state: 'change',
            params: enteredText
          });
        }
      }
      // this.goToSearchComponent();
      // console.log('searchResults: ', this.state.searchResults);
    };

    let show;
    if (this.state.searchResults) {
      show = this.state.searchResults.map((res, index) => {
        // console.log('res: ', res);
        return (
          <li
            key={index}
            className="pointer"
            // onFocus={() => this.goToSlug(`/${res.slug}`)}
            onMouseDown={() => this.goToSlug(`/${res.slug}`)}
          >
            {res.title}
          </li>
        );
      });
    }

    return (
      <SearchDiv id="Search" onClick={() => searchActive()}>
        <Image
          className="Search Icon"
          src={searchIcon}
          alt="Search Icon"
          width="24px"
          height="25px"
        />
        <input
          className="ml1"
          placeholder="Search"
          onKeyDown={e => handleInputChange(e)}
          onBlur={e => handleOnBlur(e)}
        />
        {show ? (
          <ul className="SearchList" id="SearchList">
            {show}
          </ul>
        ) : null}
      </SearchDiv>
    );
  }
}

export default withRouter(SearchBar);
